<template>
  <div>
    <el-button type="success" @click="dialogVisible = true"
      >查看员工奖励明细</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="查看员工奖励明细"
      width="1200px"
      @close="closeDialog"
      @open="search"
    >
      <div class="page-actions">
        <el-input v-model="userId" placeholder="请输入员工ID"></el-input>
        <span>时间： </span>
        <el-date-picker
          v-model="times"
          type="daterange"
          format="yyyy 年 MM 月 dd 日"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      </div>
      <el-table :data="oneday">
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="员工id"></el-table-column>

        <el-table-column prop="coinType" label="币种"></el-table-column>

        <el-table-column prop="amount" label="金额"></el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.balanceChangeStatus == 0"
              >奖励总冻结转账任务创建</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == 1"
              >奖励总冻结转账任务执行成功</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == -1"
              >奖励总冻结转账任务执行失败</span
            >
            <span v-else-if="scope.row.balanceChangeStatus == -2"
              >奖励总冻结转账任务执行超时</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import '../../store';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'kpiCreate',
  data() {
    return {
      dialogVisible: false,
      times: '',
      userId: '',
      pager: {
        page: 1,
        size: 10000
      }
    };
  },
  components: {},
  computed: {
    ...mapState('kpiProject', ['oneday', 'pagination', 'totalCounts']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  methods: {
    ...mapActions('kpiProject', ['getIdamount']),
    ...mapMutations('kpiProject', ['setPagination']),
    closeDialog() {
      this.dialogVisible = false;
    },
    search() {
      this.getIdamount({
        startTime: this.startTime,
        endTime: this.endTime,
        userId: this.userId,
        ...this.pager
      });
    },
    handleCurrentChange(page) {
      this.setPagination(page);
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
